/* assets/feature-color-adjuster.js
   Срабатывает по клику на текст «Color Adjuster» или
   через явный вызов   window.applyPalette(url)            */

;(function () {
/* ─── утилиты ─────────────────────────────────────────── */
const LOG=(...m)=>console.log('[ColorAdj]',...m);
const ERR=(...m)=>console.error('[ColorAdj]',...m);
const cors=u=>{const m=u.match(/[?&]id=([\w-]+)/)||u.match(/\/d\/([\w-]+)/)||[];
               return m[1]?`https://lh3.googleusercontent.com/d/${m[1]}=s800`:u;};
const lum=([r,g,b])=>0.2126*r+0.7152*g+0.0722*b;

/* hsl helpers */
const rgbToHsl=(R,G,B)=>{R/=255;G/=255;B/=255;
  const M=Math.max(R,G,B),m=Math.min(R,G,B);let h=0,s=0,l=(M+m)/2;
  if(M!==m){const d=M-m;s=l>.5?d/(2-M-m):d/(M+m);
    h=M===R?((G-B)/d+(G<B?6:0)):M===G?((B-R)/d+2):((R-G)/d+4);h/=6;}return[h,s,l];};
const hslToRgb=(h,s,l)=>{const f=(p,q,t)=>{t<0&&(t+=1);t>1&&(t-=1);
  if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;};
  if(!s)return[l,l,l].map(v=>v*255);const q=l<.5?l*(1+s):l+s-l*s,p=2*l-q;
  return[f(p,q,h+1/3),f(p,q,h),f(p,q,h-1/3)].map(v=>v*255);};
const brighten=r=>{let[h,s,l]=rgbToHsl(...r);l=Math.min(1,l+.4);
                   return hslToRgb(h,s,l).map(Math.round);};

/* ─── Vibrant 1.0 ────────────────────────────────────── */
const LIB='https://cdnjs.cloudflare.com/ajax/libs/vibrant.js/1.0.0/Vibrant.min.js';
const loadV=()=>window.Vibrant?Promise.resolve():new Promise((ok,bad)=>{
  const s=document.createElement('script');s.src=LIB;s.onload=ok;s.onerror=bad;
  document.head.appendChild(s);});

async function getSwatches(img){
  await loadV();
  const V=window.Vibrant,v=new V(img,16,5);
  if(typeof v.getPalette==='function')
    return new Promise((res,rej)=>v.getPalette((e,p)=>e?rej(e):res(p)));
  if(typeof v.swatches==='function') return v.swatches();
  if(typeof V.from==='function')     return V.from(img).maxColorCount(16).getPalette();
  throw Error('Vibrant API mismatch');
}

/* ─── palette generator ─────────────────────────────── */
async function makePalette(src){
  LOG('paletteFrom →',src);
  const im=new Image(); im.crossOrigin='anonymous'; im.src=cors(src); await im.decode();

  const sw=Object.values(await getSwatches(im)).filter(Boolean)
    .sort((a,b)=>{const[,sa,la]=a.getHsl();const[,sb,lb]=b.getHsl();return sb-sa||lb-la;});

  const dark=[],light=[];
  for(const s of sw){
    let rgb=s.getRgb().map(Math.round);
    if(lum(rgb)<64) rgb=brighten(rgb);
    (lum(rgb)<150?dark:light).push(rgb);
    if(dark.length>=3&&light.length>=2) break;
  }
  const p=[dark[0]||[128,128,128],dark[1]||[128,128,128],dark[2]||[128,128,128],
           light[0]||[255,255,255],light[1]||[255,255,255]];
  return {
    '--c1':`rgb(${p[0]})`,
    '--c2':`rgb(${p[1]})`,
    '--c3':`rgb(${p[2]})`,
    '--c4':`rgb(${p[3]})`,
    '--c5':`rgb(${p[4]})`
  };
}

/* ─── записываем переменные в :root + текущий SVG ────── */
function applyVars(vars){
  const root=document.documentElement.style;
  for(const[k,v] of Object.entries(vars)) root.setProperty(k,v,'');

  const svg=document.getElementById('imported-Label')?.closest('svg');
  if(svg){
    const st=svg.style;
    for(const[k,v] of Object.entries(vars)) st.setProperty(k,v,'');
  }
  console.table(vars);
}

/* ─── публичная функция ─────────────────────────────── */
async function applyPalette(src){
  if(!src){ERR('no src');return;}
  animQueue.run(async()=>{
    try{ applyVars(await makePalette(src)); }
    catch(e){ ERR(e); }
  });
}
window.applyPalette = applyPalette;

/* ─── актуальное изображение ────────────────────────── */
function getImage(){
  const label=document.getElementById('imported-Label');
  if(!label) return null;
  const byId = label.querySelector('image#ImagePlaceHolder');
  if(byId) return byId;
  const all=[...label.querySelectorAll('image')];
  return all.length? all[all.length-1] : null;
}

/* ─── делегированный клик по «Color Adjuster» ────────── */
document.addEventListener('click',ev=>{
  const txt=ev.target.closest('text.st1-answer');
  if(!txt||!/color\s*adjuster/i.test(txt.textContent)) return;
  if(!clickGuard()) return;
  const img=getImage();
  applyPalette(img?.getAttribute('href')||img?.getAttribute('xlink:href'));
},{passive:true});

LOG('ready');
})();
